import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=5895de76&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=ts&"
export * from "./Add.vue?vue&type=script&lang=ts&"
import style0 from "./Add.vue?vue&type=style&index=0&id=5895de76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5895de76",
  null
  
)

export default component.exports